<template>
<div id="app">
    <preloader v-show="this.$store.state.preloader"></preloader>
    <bounce v-show="this.$store.state.bounce"></bounce>
    <router-view :class="$store.state.showCart?'my-body-noscroll-class':''"></router-view>
    
</div>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import preloader from "./components/layout/preloader";
import bounce from "./components/layout/bounce";
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/functions';
import db from './firebase'

import VueLazyload from 'vue-lazyload'
import Vue from 'vue'

import miniToastr from 'mini-toastr';
miniToastr.init();


Vue.use(VueLazyload, {  
    loading: '/images/loading-bar-animated-gif-transparent-background-5.gif',
  attempt: 3,
  preLoad:1.1
})
// db.collection(setId).where("Users", "array-contains", this.state.user.email).onSnapshot(snapshot => {
//             context.commit('updateLoading', true)
//               snapshot.docChanges().forEach(change => {
//                 let tmpDoc = change.doc.data()
//                 tmpDoc.id = change.doc.id
//                 const source = change.doc.metadata.hasPendingWrites ? 'Local' : 'Server'
//                   if (source === 'Server') {
//                     if (change.type === 'added') {
//                     context.commit('addCloudSet', {setId:setId, item:tmpDoc})
//                   }
//                 }
//                   if (change.type === 'modified') {
//                     context.commit('updateCloudSet', {setId:setId, item:tmpDoc})
//                   }
//                   if (change.type === 'removed') {
//                     context.commit('deleteCloudSet', {setId:setId, id:change.doc.id} )
//                   }
                              
//               })
//               context.commit('updateLoading', false)
//             })

//import icheck from "../static/iCheck/icheck.min.js";
export default {
    name: 'app',
    components: {
        preloader,
        bounce
        },
    data() {
        return {
            inPreviewTime:'no',
            user:{},
            name:'',
            idTokenResult:{},
            showTASModal:false,
            TermsAndConditions:''
        }
    },
    computed:{
        userCC(){
            return this.$store.state.auth.userCC?this.$store.state.auth.userCC:{};
        },   
    },
    watch: {
            inPreviewTime (newVal,oldVal){
                console.log('inPreviewTime oldVal',oldVal,'newVal',newVal);
                if(oldVal=='yes' && newVal=='no'){     
                    miniToastr.success('Reloading platform',"New Tender about to start")               
                    setTimeout(() => {
                        location.reload()
                }, 3000);

                }
            }
    },
    methods:{
        procceedNext(){
            miniToastr.info("Loading Your Profile...","Welcome "+this.$store.state.name+",")
            this.$store.state.auth.userCC = this.$store.state.idTokenResult.claims
            this.$store.dispatch('autoSignIn', this.$store.state.user)
            var that=this
            var getItems = firebase.functions().httpsCallable("circaEP");
            that.$store.dispatch('getFavorites')
            that.$store.dispatch('getMyPurchases')
            that.$store.dispatch('getMyBids')
            if(that.$store.state.feed.length==0 && !that.$store.state.fetchingFeed)
            {
            that.$store.state.fetchingFeed=true;
                getItems({action:'getItems'})
                    .then(function(result) {
                        that.$store.state.feed = JSON.parse(JSON.stringify(result.data))                                         
                        that.$store.state.fetchingFeed=false;                         
                        that.$store.state.galleryState.reloadData=true  
                        if(that.$store.state.feed.length==0){
                            that.$router.push('/noItems')
                        }  
                        else{                            
                            setTimeout(() => {
                                var tmp = that.$route.query.redirect
                                var dest='/'
                                if(tmp)
                                    dest='/'+tmp
                                if(tmp=='mydashboard')
                                    that.$store.state.myDashboardTabId=1
                                dest = dest.replace('//','/')
                                if(dest=='/'){
                                    var counter=0
                                    var cat = ''
                                    if(that.userCC.Diamonds || that.userCC.DiamondsVIP){cat='Diamonds'; counter++;}
                                    if(that.userCC.Jewelry || that.userCC.JewelryVip) {cat='Jewelry'; counter++;}
                                    if(that.userCC.Watches || that.userCC.WatchesVIP) {cat='Watches'; counter++;}
                                    if(counter==1)
                                        that.goToGallery(cat)
                                    else
                                        that.$router.push(dest)   
                                    
                                    var categories = [...new Set(that.$store.state.feed.map(x=>x["Jewelry Cage"]))]
                                    var tmpCounter=0
                                    var category = categories[0]
                                    categories.forEach(category=>{
                                        if(category.includes('Diamond') && (that.userCC.Diamonds || that.userCC.DiamondsVIP)){                                            
                                            if(cat!='Diamonds'){
                                                cat='Diamonds'
                                                tmpCounter++
                                            }                                                
                                        }
                                        else if(category=='Watches' && (that.userCC.Watches || that.userCC.WatchesVIP)){
                                            cat='Watches'
                                            tmpCounter++
                                        }
                                        else if((category=='Signed Pieces' || category=='General Jewelry') && (that.userCC.Jewelry || that.userCC.JewelryVIP)){
                                            cat='Jewelry'
                                            tmpCounter++
                                        }
                                    })                                    
                                    if(tmpCounter==1){
                                        that.checkIfInPreview()
                                        that.goToGallery(cat)
                                    }
                                }
                                else{
                                    that.checkIfInPreview()
                                    that.$router.push(dest)                                
                                }  
                            },2000)
                        }                           
                    })
                    .catch(function(error) {
                        that.state.fetchingFeed=false;                               
                    });
            }else
            {
            }
        },
        goToGallery(cat){
            if(this.$store.state.cat!=cat){
                this.$store.state.cat=cat
                this.$store.state.galleryState.filtersVisible=[]
                for (var i = 1; i < 100; i++) {
                        this.$store.state.galleryState.filtersVisible.push(false)
                }
                this.$store.state.galleryState ={
                
                sortBy:'Sort By...',
                sizesFilter:[0,20],
                maxSize:20,
                showMoreFilters:false,
                reloadFilters:false,
                showClearFilters:false,
                search:'',
                isActive:'',
                filters:{},
                emmitedFilter:{},
                filtersVisible:{},
                list:[],
                bigList:[],
                }
                if(cat!='Diamonds')
                    this.$store.state.galleryState.showMoreFilters=true;
                this.$store.state.galleryState.reloadData=true
            }
            this.$router.push("/"+this.$store.state.cat.toLowerCase())
        },
        checkIfInPreview(){
            var that=this
            setTimeout(() => {
                var previewTimes = [...new Set(that.$store.state.feed.map(x=>{
                    try{
                        return that.formatSalesCycle(x["Sales Cycle Preview Date"],x["Sales Cycle Preview Time"])
                    }
                    catch(e){
                        return ''
                    }                    
                    }))][0]

                var startTimes = [...new Set(that.$store.state.feed.map(x=>{
                    try{
                        return that.formatSalesCycle(x["Sales Cycle Start Date"],x["Sales Cycle Start Time"])
                    }
                    catch(e){
                        return ''
                    }                    
                    }))][0]
                
                if(previewTimes=='Auction Expired'){
                    
                    if(startTimes.length>0 && startTimes!='Auction Expired'){
                        
                        if(that.inPreviewTime!='yes')
                            that.inPreviewTime='yes'
                        that.checkIfInPreview()
                    }
                    else{
                        
                        if(that.inPreviewTime!='no')
                            that.inPreviewTime='no'
                    }
                }
            }, 5000);
        },
        formatSalesCycle(salesCycleEndDate,salesCycleEndTime){
                var timeZoneName='EST'
                try{
                    var tmp = new Date().toLocaleString("en-US", {timeZone: "America/New_York", timeZoneName: "short"})
                    if(tmp.indexOf(' EDT')>0)
                        timeZoneName='EDT'
                }
                catch(e){
                    
                }
                //salesCycleEndTime=12
                if(Number(salesCycleEndTime)==false){
                    salesCycleEndTime=12
                }
                salesCycleEndTime=salesCycleEndTime+':00:00'
                salesCycleEndDate = salesCycleEndDate+' '+salesCycleEndTime+' '+timeZoneName
                //console.log(salesCycleEndDate);
                var tmp = new Date(salesCycleEndDate)

                var date1 = new Date(new Date().toLocaleString("en-US", {timeZone: "America/New_York"}))
                var date2= new Date(new Date(tmp).toLocaleString("en-US", {timeZone: "America/New_York"}))
                
                var date1_ms = date1.getTime();
                var date2_ms = date2.getTime();

                // Calculate the difference in milliseconds
                var difference_ms = date2_ms - date1_ms;
                var one_hour=1000*60;
                
                // Convert back to days and return
                var res = difference_ms/one_hour; 

                var endTime={
                hours: Math.floor(res/60),
                minutes: Math.floor(res%60),
                seconds: Math.floor(difference_ms/1000%60),
                }
                
                if(this.counterTypeShort)
                {
                    if(difference_ms>0)
                        return endTime;   
                    else{
                        this.auctionExpired=true;
                        return 'Auction Expired'
                    }
                }
                else{
                    if(res<0){
                        this.auctionExpired=true;
                        res = 'Auction Expired'
                    }
                    else{
                        res=("0" + endTime.hours).slice(-3)+"h:"+("0" + endTime.minutes).slice(-2)+'m:'+("0" + endTime.seconds).slice(-2)+'s'
                    }
                    // else if(endTime.days>3)
                    //     res="Bids for this item will be accepted for "+endTime.days+" days"
                    // else if(endTime.days>0)
                    //     res="Bids for this item will be accepted for "+endTime.days+" days, " +endTime.hours+" hours, "+endTime.minutes+" minutes and "+endTime.seconds+" seconds"
                    // else if(res>60)                
                    //     res="Bids for this item will be accepted for " +endTime.hours+" hours and "+endTime.minutes+" minutes and "+endTime.seconds+" seconds"
                    // else if(res<60)
                    //     res="Bids for this item will be accepted for "+endTime.minutes+" minutes and "+endTime.seconds+" seconds"
                    // else{
                    //     res = 'Auction Expired'
                    //     this.auctionExpired=true;
                    // }
                }
                return res;
            },  
    },
    mounted() {            
        firebase.auth().onAuthStateChanged((user) => {
        if (user) {
            firebase.auth().currentUser.getIdTokenResult()
            .then((idTokenResult) => {              
                    try{      
                    gtag('config', 'UA-1801250-8', {'user_id': user.email});
                    gtag('set',{'user_id': user.email});
                    gtag('event', 'login');
                    }
                    catch(e){}
                    // this.$store.state.audio = document.getElementById("chachingaudio"); 
                    // this.$store.state.audio2 = document.getElementById("chachingaudio2"); 
                    // this.$store.state.audio3 = document.getElementById("chachingaudio3");   
                    var userAgreedToTerms = false
                    var name = user.displayName
                    try{
                        if(user.photoURL){
                            var tmp = user.photoURL
                            tmp = tmp.replace('http://','')
                            tmp = JSON.parse(atob(tmp))
                            name = tmp.firstName
                            if(tmp && tmp.termsConfirmed){
                                userAgreedToTerms=true
                            }
                        }
                    }
                    catch(e){
                        console.log(e);
                        
                    }
                    if(!userAgreedToTerms){
                        var that=this
                        db.collection('TermsAndConditions').doc('static').get().then(doc2 =>{
                            const data = doc2.data()
                            data.id = doc2.id;
                            that.TermsAndConditions = data.content
                            that.showTASModal=true;
                            that.$store.state.needToConfirmTAS = true;
                            that.$store.state.TAS = data.content                            
                        })
                    }
                    this.$store.state.user = user
                    this.$store.state.name = name
                    this.$store.state.idTokenResult = idTokenResult                    
                    this.procceedNext()
                    
                    
                })
                .catch((error) => {
                    console.log('error',error);
                    
                });
            
        }
        })
        // db.collection("cities").doc("SF")
        // .onSnapshot(function(doc) {
        //     console.log("Current data: ", doc.data());
        // });
        //const getUserRef = userId => db.ref(`/users/${userId}`);
        var that=this
        const ensureUserSession= function(userId) {            
        return new Promise((resolve, reject) => {            
            const getUserRef = userId => db.collection("users").doc(userId);
            const userRef = getUserRef(userId);
            return userRef.onSnapshot(function(doc) {                    
                var currentUser = firebase.auth().currentUser
                var userObj = JSON.parse(JSON.stringify(currentUser))                  
                const user = doc.data();     
                var lastLoginAtLocal = localStorage.getItem('lastLoginAt').toString()
                var lastLoginAtServer = user.lastLoginAt.toString()

                if (lastLoginAtLocal != lastLoginAtServer) {                                    
                    that.$store.dispatch('logout')
                    localStorage.setItem('alo',true)
                }
                return resolve(user);
            });
        })
    };
        
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                return ensureUserSession(user.uid)
                    .then(() => {                        
                        // const userRef = db.collection("users").doc(user.uid);                        
                        // return userRef
                        //     .set({
                        //         is_online: true,
                        //         last_seen: new Date()
                        //     })
                    }).catch(err => {
                        console.error(err);
                        //return firebase.auth().signOut();
                    });
            }
        });
    }    
}
</script>
<style lang="scss" src="./assets/sass/bootstrap/bootstrap.scss"></style>
<style src="font-awesome/css/font-awesome.min.css"></style>
<style src="./assets/themify-icons/css/themify-icons.css"></style>
<style>
.heart{
    background-color: black;
    /* background-image:url('/images/heart.svg'); */
    -webkit-mask-image:url('/images/heart.svg');
    mask-image:url('/images/heart.svg');

    width:30px;
    height:30px;
}
.heartfull{
    background-color: red;
    /* -webkit-mask-image: url(icon.svg);
    mask-image: url(icon.svg); */
    -webkit-mask-image:url('/images/heartfull.svg');
    mask-image:url('/images/heartfull.svg');
    width:30px;
    height:30px;
}

.link{
    color:#6699cc !important;
    cursor: pointer;
}
.pointer{
    cursor: pointer;
}
.modal-dialog {
    top: 50%;
    min-width: 300px;
    margin: 0 0 0 50%;
    transform: translate(-50%, -50%) !important;
}
.my-body-noscroll-class {
    overflow: hidden;
    position: fixed;
    height: 100%;
}
.btn{
    text-transform: uppercase;
}
    .vip{
        filter: invert(7%) sepia(200%) saturate(476%) hue-rotate(180deg) brightness(118%) contrast(119%);
    }
    .vip2{
        filter: invert(7%) sepia(200%) saturate(476%) hue-rotate(280deg) brightness(118%) contrast(119%);
    }
    .vip3{
        filter: invert(7%) sepia(200%) saturate(76%) hue-rotate(0deg) brightness(218%) contrast(119%);
    }
    .rounded{
    border-radius: 0.8em !important;
    }
    .whiteshad{
        -webkit-box-shadow: 2px 2px 6px #0a62aa;
    }
    
    .view-icons{
        font-size: medium;
    }
    .product_box{
        width:23.7%
    }
    .sale-tag{
        margin-top: 10px;
        position: absolute;
    }
    .product_description{
        display: none;
    }
    .sale-tag:after{
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        left: 30px;
        right: auto;
        top: 0px;
        bottom: auto;
        border: 10px solid;
        border-color: #ff6666  transparent transparent transparent;
    }
    .sale-tag:before{
        content: ' ';
        position: absolute;
        width: 0;
        height: 0;
        left: 30px;
        right: auto;
        top: -1px;
        bottom: auto;
        border: 10px solid;
        border-color:  transparent transparent  #ff6666 transparent;
    }
    .fullwidth{
        width: 100%;
    }
    .fullwidth .product_description{
        display: block;
    }
    
    @media(min-width: 768px) and (max-width:1024px){
        .product_box{
            width:31.5%;
        }
        .fullwidth {
            width:100%;
        }
    }
    @media(min-width:320px) and (max-width:425px) {
        .product_box{
            width: 96%;
        }
        .fullwidth .card-body{
            padding: 2.5rem;
        }
    }
    @media(min-width: 426px) and (max-width:767px){
        .product_box{
            width:46.5%;
        }
    }

    .boxed .product_box{
        width:23.5%
    }
    @media(min-width:768px) and (min-width:768px){
        .boxed .product_box{
            width:30%
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/App.vue